export const getLiveVideoStreamStatisticsData = {
  request: 'statisticData/get_statistic_data_request',
  success: 'statisticData/get_statistic_data_success',
  failure: 'statisticData/get_statistic_data_failure',
};
